import { withLoginUser } from 'src/api/user'
import { GuestPageWrapper, MemberPageWrapper } from 'src/components/PageWrapper'
import { ContentPageLayout } from './ContentPageLayout'

export const ContentPage = withLoginUser(({ user, loggedIn }) => {
  return (
    <>
      {loggedIn ? (
        <MemberPageWrapper user={user} currentPath="経営コラム">
          <ContentPageLayout />
        </MemberPageWrapper>
      ) : (
        <GuestPageWrapper>
          <ContentPageLayout />
        </GuestPageWrapper>
      )}
    </>
  )
})
